export function initAlerts() {
  // hide alert, when click at close-button
  const alertIcons = document.querySelectorAll('.js-alert-close-button');
  alertIcons.forEach(element => {
    element.addEventListener('click', (event: Event) => {
      (event.target as HTMLElement)!.closest('.alert__wrapper')!.classList.add('hide');
    });
  });
}
